import React from 'react';
import * as Icons from 'react-icons/md';
import imgSharedFolder from '../../../static/images/coloricons/shared-folder.svg';
import imgFolder from '../../../static/images/coloricons/folder.svg';
import imgPdf from '../../../static/images/coloricons/pdf.svg';
import imgWord from '../../../static/images/coloricons/word.svg';
import imgExcel from '../../../static/images/coloricons/excel.svg';
import imgPowerpoint from '../../../static/images/coloricons/powerpoint.svg';
import imgVideo from '../../../static/images/coloricons/video.svg';
import imgSound from '../../../static/images/coloricons/sound.svg';
import imgImage from '../../../static/images/coloricons/image.svg';
import imgChat from '../../../static/images/coloricons/chat.svg';
import imgQuestionMultipleChoice from '../../../static/images/coloricons/question-multiple-choice.svg';
import imgRingSvg from '../../../static/images/ring.svg';

export default function displayFileIcon(file: any) {
    let fileIcon = null;
    {
        if (file.fileName && file.fileName.lastIndexOf('.') > 0) {
            const ext = file.fileName.substr(file.fileName.lastIndexOf('.') + 1);

            if (ext === 'pdf') {
                fileIcon = <img src={imgPdf} />;
            } else if (ext === 'ppdf') {
                fileIcon = <img src={imgPdf} />;
            } else if (/docx?/gi.test(ext)) {
                fileIcon = <img src={imgWord} />;
            } else if (/xlsx?/gi.test(ext)) {
                fileIcon = <img src={imgExcel} />;
            } else if (/pptx?/gi.test(ext)) {
                fileIcon = <img src={imgPowerpoint} />;
            } else if (/mp4/gi.test(ext)) {
                fileIcon = <img src={imgVideo} />;
            } else if (/mp3/gi.test(ext)) {
                fileIcon = <img src={imgSound} />;
            } else if (/chat/gi.test(ext)) {
                fileIcon = <img src={imgChat} />;
            } else if (/forum/gi.test(ext)) {
                fileIcon = <img src={imgQuestionMultipleChoice} />;
            } else if (/jpe?g|png|gif/gi.test(ext)) {
                fileIcon = <img src={imgImage} />;
            } else {
                fileIcon = <Icons.MdInsertDriveFile size="22" />;
            }
        } else {
            fileIcon = <Icons.MdInsertDriveFile size="22" />;
        }
    }
    return fileIcon;
}
